import { MONTHS } from "constant/variables";
import React from "react";
import { Label, Input } from "reactstrap";

const MonthsDropdown = ({
  value,
  onChange,
  label = "Month",
  className = "",
}) => {
  return (
    <div className={`col-md-12 col-sm-12 ${className}`}>
      <Label>{label}</Label>
      <Input
        type="select"
        name="select"
        className="form-control digits uiStyleDashboard"
        value={value}
        onChange={onChange}
      >
        <option value="">Select</option>
        {MONTHS.map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </Input>
    </div>
  );
};

export default MonthsDropdown;
